import {Component, inject, Input, OnInit, signal} from "@angular/core";
import {NgClass} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";

@Component({
  selector: 'lang-button',
  imports: [
    NgClass,
    TranslateModule,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger
  ],
  template: `
    <div>
      <button class="header__select" [matMenuTriggerFor]="langMenu">
        @if(buttonType === 'black'){
        <img src="/images/icons/lang.svg" class="w-5 md:w-6 h-auto" alt="">
        } @else if (buttonType === 'white'){
          <img src="/images/icons/lang-white.svg" class="w-5 md:w-6 h-auto" alt="">
        } @else{
          <img src="/images/icons/lang.svg" class="w-5 md:w-6 h-auto" alt="">
        }

        <span [ngClass]="buttonType === 'black' ? 'text-black' : 'text-white'">{{ activeLang().value }}</span>
      </button>

      <mat-menu #langMenu="matMenu" class="custom-menu">
        @for (item of langList(); track item.img) {
          <button mat-menu-item (click)="changeLanguage(item)" [class.selected]="activeLang().lang === item.lang">
            <span>{{ item.value }}</span>
          </button>
        }
      </mat-menu>
    </div>
  `,
  styles: ``
})

export class LanguageButtonComponent implements OnInit{
  #fb = inject(FormBuilder);
  @Input() buttonType : 'black' | 'white' = 'black';

  activeLang = signal({
    lang: 'ru',
    value: 'Ru',
    img: '/images/flags/russia.svg'
  })

  langList = signal([
    {lang: 'ru', value: 'Рус', img: '/images/flags/russia.svg'},
    {lang: 'en', value: 'English', img: '/images/flags/united-kingdom.svg'},
    {lang: 'uz', value: 'Uzbek', img: '/images/flags/uzbekistan.svg'},
  ])

  langModel: FormGroup = this.#fb.group({
    lang: 'ru'
  })

  ngOnInit(): void {
    const lang = localStorage.getItem("lang");
    if (lang) {
      const active = this.langList().find(item => item.lang === lang);
      if (active) {
        this.activeLang.set(active);
      }
      this.langModel.patchValue({
        lang: lang,
      });
    }
  }

  changeLanguage(item: { lang: string, value: string, img: string }): void {
    // const lang: 'uz' | 'ru' | 'en' = event.target.value;
    this.activeLang.set(item);
    localStorage.setItem('lang', item.lang);
    window.location.reload();
  }
}
